import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { type WishlistTags, wishlistTags } from "../schemas/wishlistTags";

export const getWishlistTagsProps = z
  .object({
    token: z.string(),
  })
  .extend(requestConfig.shape);

export type GetWishlistTagsProps = z.infer<typeof getWishlistTagsProps>;

export const getWishlistTags = async (
  args: GetWishlistTagsProps,
): Promise<WishlistTags> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    token,
    proxyAuthSecret,
  } = parseServiceInput(getWishlistTagsProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    ...(proxyAuthSecret && { "X-NG-Proxy-Auth": proxyAuthSecret }),
  });

  const response = await fetch(`${endpoint}/v3/wishlist/tag`, {
    method: "GET",
    headers,
  });

  return parseServiceOutput(response, wishlistTags, {
    code: "MALFORMED_WISHLIST",
    message: "Wishlist is malformed",
  });
};
